module.exports = __webpack_public_path__ + "static/media/logo.01476c57.png";